/* KIRA — filtres + tri de la grille collection (scopé par section) */
(function(){
  function init(root){
    var grid=root.querySelector('[data-kira-grid]'),chips=root.querySelector('[data-kira-chips]'),
        count=root.querySelector('[data-kira-count]'),sort=root.querySelector('[data-kira-sort]');
    if(!grid)return;
    var cards=[].slice.call(grid.children),cat='all';
    function render(){
      var vis=cards.filter(function(c){return cat==='all'||c.dataset.cat===cat;});
      var s=sort?sort.value:'featured',ord=vis.slice();
      if(s==='asc')ord.sort(function(a,b){return a.dataset.price-b.dataset.price;});
      else if(s==='desc')ord.sort(function(a,b){return b.dataset.price-a.dataset.price;});
      else if(s==='name')ord.sort(function(a,b){return a.dataset.name.localeCompare(b.dataset.name,'fr');});
      cards.forEach(function(c){c.style.display='none';});
      ord.forEach(function(c){c.style.display='block';c.style.animation='none';c.offsetHeight;c.style.animation='';grid.appendChild(c);});
      if(count)count.textContent=vis.length+(vis.length>1?' pièces':' pièce');
    }
    if(chips)chips.addEventListener('click',function(e){
      var b=e.target.closest('.chip');if(!b)return;
      [].forEach.call(chips.children,function(x){x.classList.toggle('is-on',x===b)});
      cat=b.dataset.cat;render();
    });
    if(sort)sort.addEventListener('change',render);
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-kira-collection]'),init)}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',function(e){
    var r=e.target.querySelector('[data-kira-collection]');if(r)init(r);
  });
})();
